// Module
var code = "<svg width=\"19\" height=\"19\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M9.778 8.364L17.556.586 18.971 2l-7.779 7.778 7.779 7.778-1.415 1.415-7.778-7.779L2 18.971.586 17.556l7.778-7.778L.586 2 2 .586l7.778 7.778z\" fill=\"#fff\" fill-rule=\"nonzero\"/>\n</svg>\n";
// Exports
export default code;